/**
 * Design tokens - the single source of truth for the Royal Dastinos brand.
 *
 * No component should hardcode a brand color literal; reference the theme
 * (theme.palette.*) which is derived from these tokens.
 */

export const colors = {
  // Brand terracotta. `main` passes WCAG AA (>= 4.5:1) for white text on it
  // (~4.8:1). The brighter `#FF7420` is kept as an accent/hover only, never
  // as a background behind white text.
  terracotta: '#C24E00',
  terracottaAccent: '#FF7420',
  terracottaLight: '#FF9554',
  terracottaDark: '#9A3E00',

  // Warm sand neutrals (secondary + surfaces).
  sand: '#E8E0D1',
  sandLight: '#F5F1E8',
  sandDark: '#C9C2B3',

  // Text / ink.
  ink: '#2A2A2A',
  inkSoft: '#6B6B6B',

  // Surfaces.
  background: '#F5F1E8',
  paper: '#FFFFFF',
  white: '#FFFFFF',

  // Semantic hues - each distinct (info was previously the brand orange).
  success: '#2E7D32',
  successLight: '#4CAF50',
  successDark: '#1B5E20',

  info: '#0277BD',
  infoLight: '#4FC3F7',
  infoDark: '#01579B',

  warning: '#ED6C02',
  warningLight: '#FF9800',
  warningDark: '#E65100',

  error: '#D32F2F',
  errorLight: '#EF5350',
  errorDark: '#C62828',

  divider: 'rgba(0, 0, 0, 0.08)',
};

export const fonts = {
  heading: '"Playfair Display", "Georgia", serif',
  body: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
};

export const fontWeights = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};

export const radius = 4;
